






























import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BudgetSubItem from "@/models/porposal/budgetSubItem.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from "@/services/user.service";
import { PermissionValue } from "@/enums/PermissionValue";
@Component
export default class BudgetSubItemTableComponent extends GenericBTable<
  BudgetSubItem
> {
  created() {
    this.permissionValue = PermissionValue.GASTOPRESUPUESTO;
    this.tableConfig.controller = "BudgetSubItem";
    this.tableConfig.whereParams = `budgetItemId eq 
     ${this.$route.params.budgetItemId}`;

    this.formatColumns();
  }
  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    let budgetItemCalculation = new BTableColumn(
      "budgetItemCalculationName",
      "table.budgetItemCalculation",
      false
    );
    this.tableConfig.insertColumns(name, budgetItemCalculation);
  }
}
